import {Component, OnInit} from '@angular/core';
import {NotificationItem} from './notification.model';
import {HttpService} from '../../core';
import {NotificationService} from '../../core/services/notification.service';

@Component({
    selector: 'app-notification',
    templateUrl: 'notification.component.html',
    styleUrls: ['notification.component.scss']
})
export class NotificationComponent implements OnInit {
    notificationArray: NotificationItem[];
    unreadNotificationCount: number;
    pageIndex: number;
    pageSize: number;
    length: number;
    selectedIndex: number;
    isLoading: boolean;
    pageSizeOptions: number[] = [5, 10, 25, 100];

    constructor(public notificationService: NotificationService, private httpService: HttpService) {
        this.selectedIndex = 0;
    }

    ngOnInit() {
        this.isLoading = true;
        this.getNotification('', 25);
    }

    // 获取消息
    getNotification(status, pageSize, e?) {
        this.notificationService.getNotification(status, e ? e.pageIndex : 0, e ? e.pageSize : pageSize).then(() => {

            this.notificationArray = this.notificationService.notificationArray;
            this.pageIndex = this.notificationService.pageIndex;
            this.pageSize = this.notificationService.pageSize;
            this.length = this.notificationService.length;
            this.isLoading = false;
            this.notificationService.checkUnreadNotification().then(() => {
                this.unreadNotificationCount = this.notificationService.unreadNotificationCount;
            });
        });
    }

    // 把全部消息标为已读
    markAllAsRead(notificationArray: NotificationItem[]) {
        notificationArray.forEach((eachNotificationItem: NotificationItem) => {
            eachNotificationItem.notificationReceivers.forEach((eachReceiver: any) => {
                eachReceiver.status = 1;
            });
            this.httpService.putNotificationStatusByAuth(eachNotificationItem.id).toPromise().then((res) => {
                console.log(res);
            });
            this.unreadNotificationCount = 0;
            this.notificationService.unreadNotificationCount = this.unreadNotificationCount;
        });
    }

    // 减少未读消息数量
    reduceUnreadCount() {
        if (this.unreadNotificationCount > 0) {
            this.unreadNotificationCount--;
        }
        if (this.notificationService.unreadNotificationCount > 0) {
            this.notificationService.unreadNotificationCount--;
        }
    }

    // 切换tab
    changeTab() {
        if (this.selectedIndex === 0) {
            this.getNotification('', 25);
        } else {
            this.getNotification(0, 25);
        }
    }
}
